import { useNavigate } from "react-router-dom";
import Points from "../points/Points";
import { Avatar } from "../Avatar";
import { getValidImageUrl } from "../../utils";

const Header = ({ profile }) => {
  const navigate = useNavigate();
  const imageUrl = getValidImageUrl(
    profile?.audience_badge_image_url,
    "/image/BronzeMedal.png"
  );

  return (
    <div className="overflow-y-hidden flex justify-between items-center pt-10 pb-10 px-4 rounded-t-[30px]">
      <div className="flex items-center gap-2">
        {profile?.profile_image ? (
          <div
            onClick={() => navigate("/settings/profile")}
            className="p-0.5 border-gradient rounded-full w-fit cursor-pointer"
          >
            <img
              className="w-10 h-10 object-cover rounded-full"
              src={profile?.profile_image}
              alt="Profile_image"
              loading="lazy"
            />
          </div>
        ) : (
          <Avatar
            onClick={() => navigate("/settings/profile")}
            firstName={profile?.first_name}
            lastName={profile?.last_name}
          />
        )}
        <div>
          <p className="text-sm font-medium text-white">
            {profile?.first_name
              ? `${`${profile?.first_name} ${profile?.last_name}`}`
              : profile?.email}
          </p>
          <div className="bg-[#FFFFFF1C] py-1.5 px-2.5 w-fit rounded-full flex items-center gap-1 justify-center">
            <img
              src={imageUrl}
              alt={profile?.current_badge_name || "User current badge"}
              className="w-2.5 h-3 object-contain"
              loading="lazy"
            />
            <span className="text-[0.5rem] font-bold text-white">
              {profile?.audience_badge_name ?? "Novice"}
            </span>
          </div>
        </div>
      </div>
      <Points className="bg-[#00000066]" userPoints={profile?.points} />
    </div>
  );
};

export default Header;
